import * as z from "zod";

/** A pending settings change as surfaced to admin reviewers. */
export const pendingSettingsChange = z.object({
  /** CockroachDB row id (bigint serialized as string). */
  id: z.string(),
  /** Mongo Team ObjectId (hex). */
  teamId: z.string(),
  resource: z.string(),
  /** Target Mongo document ObjectId (hex). */
  resourceId: z.string(),
  path: z.string(),
  /** Human-readable label for the changed setting, or null if none defined. */
  label: z.string().nullable(),
  prev: z.unknown(),
  next: z.unknown(),
  proposedBy: z.string(),
  proposedByUserId: z.string().nullable(),
  createdAt: z.date(),
});
export type PendingSettingsChange = z.infer<typeof pendingSettingsChange>;
